const { REACT_APP_REST_ENDPOINT } = process.env;

export default class PaymentService {

    static verifyPayment = async (sessionId) => {
        try {
            const response = await fetch(
                `${REACT_APP_REST_ENDPOINT}/stripe/verify-payment`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        session_id: sessionId
                    })
                }
            );
      
            const data = await response.json();
          
            if (!response.ok) {
                throw new Error(data.message || 'Errore durante la verifica del pagamento');
            }
      
            return data;
        } catch (error) {
            console.error('Errore in verifyPayment:', error);
            throw error;
        }
    };

}
